import { MerchantDetail } from 'src/interfaces/merchants';
import { MerchantBookingPageApiResponse } from 'src/interfaces/merchants/bookings';

export const toThumbnailUrl = (args: {
  bookingData: MerchantBookingPageApiResponse;
  merchantDetail: MerchantDetail;
}) => {
  const { bookingData, merchantDetail } = args;
  if (bookingData.primary_image && bookingData.primary_image.square) {
    return bookingData.primary_image.square.url;
  }
  // 動画のサムネイル
  if (bookingData.cover_content) {
    return bookingData.cover_content.thumbnail_url;
  }
  // nothing (PhotoGallaryから一枚昇格してメインイメージとして表示される)
  return merchantDetail.cover_image.url;
};
